import React, { useState } from "react";
import { Modal, Input, List } from "antd";
import countries from "../../../constants/countries.json";
import ReactCountryFlag from "react-country-flag";
import "./index.scss";

interface Country {
  isoCode: string;
  phoneCode: string;
  name: string;
  iso3Code: string;
}

interface CountrySelectorModalProps {
  visible: boolean;
  onClose: () => void;
  onSelect: React.Dispatch<React.SetStateAction<Country | null | undefined>>;
}

const CountriesModal: React.FC<CountrySelectorModalProps> = ({
  visible,
  onClose,
  onSelect,
}) => {
  const [search, setSearch] = useState<string>("");

  const filteredCountries = countries.filter(
    (country) =>
      country.name.toLowerCase().includes(search.toLowerCase()) ||
      country.phoneCode.includes(search)
  );

  return (
    <Modal
      title="Select Country"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      className="countries-modal custom-modal"
    >
      <Input
        className="search-input"
        placeholder="Search..."
        onChange={(e) => setSearch(e.target.value)}
        allowClear
      />
      <List
        className="countries-list"
        dataSource={filteredCountries}
        renderItem={(country) => (
          <List.Item
            key={country.isoCode}
            onClick={() => {
              onSelect(country);
              onClose();
            }}
            style={{
              cursor: "pointer",
              display: "grid",
              gridTemplateColumns: "repeat(3 ,1fr)",
              alignItems: "center",
            }}
          >
            <ReactCountryFlag
              svg
              countryCode={country.isoCode || country.iso3Code}
            />
            <span>{country.phoneCode}</span>
            <span>{country.name}</span>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default CountriesModal;
